import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom';
import Parse from 'parse';

// Parse.initialize(process.env.REACT_APP_API_APP_ID, "");
Parse.initialize("8o3XCNffZScEf6117bhggd7Z6ySOItmXGkcJaN21V6A", "");
Parse.serverURL = "https://api.trench.app"; //process.env.REACT_APP_API_SERVER_URL;
// console.log(process.env.REACT_APP_API_HOST);

ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
    document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js